import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../../../styles/KidsPartyFun.css';

const KidsPartyFun = ({ isPreview = true }) => {
  const { celebrantName } = useParams();
  const [isRevealed, setIsRevealed] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [rsvpData, setRsvpData] = useState({
    name: '',
    attending: '',
    guests: '1',
    message: ''
  });

  // Parse celebrant name
  const formatName = (name) => {
    if (!name) return 'Birthday Star';
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };

  const invitationData = {
    celebrantName: formatName(celebrantName),
    age: '7',
    partyDate: 'June 15, 2026',
    partyDay: 'Saturday',
    partyTime: '2:00 PM',
    venue: 'Fun Zone Play Center',
    venueAddress: 'SM Mall of Asia, Pasay City',
    theme: 'Superhero Adventure',
    message: 'Join us for an amazing day of fun, games, and cake!',
    dressCode: 'Come in your favorite superhero costume!',
    activities: 'Games, Magic Show, Face Painting'
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsRevealed(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="kids-party-fun">
      {/* Fun Elements */}
      <div className="fun-elements">
        <div className="balloon balloon-1">🎈</div>
        <div className="balloon balloon-2">🎈</div>
        <div className="balloon balloon-3">🎈</div>
        <div className="star star-1">⭐</div>
        <div className="star star-2">✨</div>
        <div className="star star-3">🌟</div>
        <div className="confetti confetti-1">🎊</div>
        <div className="confetti confetti-2">🎉</div>
      </div>

      {/* Main Content */}
      <div className={`kids-container ${isRevealed ? 'revealed' : ''}`}>
        {/* Navigation */}
        <nav className="kids-nav">
          <button 
            className={activeSection === 'home' ? 'active' : ''} 
            onClick={() => setActiveSection('home')}
          >
            🏠 Home
          </button>
          <button 
            className={activeSection === 'details' ? 'active' : ''} 
            onClick={() => setActiveSection('details')}
          >
            🎁 Details
          </button>
          <button 
            className={activeSection === 'rsvp' ? 'active' : ''} 
            onClick={() => setActiveSection('rsvp')}
          >
            ✉️ RSVP
          </button>
        </nav>

        {/* Home Section */}
        {activeSection === 'home' && (
          <section className="kids-section home-section">
            <div className="party-frame">
              <div className="frame-top">🎈🎉🎈🎉🎈</div>
              
              <div className="home-content">
                <p className="party-prefix">You're Invited to</p>
                
                <div className="celebrant-name">
                  <span className="name">{invitationData.celebrantName}'s</span>
                  <span className="birthday-text">Birthday Party!</span>
                </div>

                <div className="age-badge">
                  <span className="turning">Turning</span>
                  <span className="age-number">{invitationData.age}</span>
                </div>

                <div className="fun-divider">
                  <span>🎂</span>
                  <span>🎁</span>
                  <span>🎂</span>
                </div>

                <p className="invitation-text">{invitationData.message}</p>

                <div className="party-date-display">
                  <div className="date-balloon">
                    <span className="day-name">{invitationData.partyDay}</span>
                    <span className="full-date">{invitationData.partyDate}</span>
                    <span className="time">🕐 {invitationData.partyTime}</span>
                  </div>
                </div>

                <button 
                  className="view-details-btn"
                  onClick={() => setActiveSection('details')}
                >
                  🎁 See Party Details
                </button>
              </div>

              <div className="frame-bottom">🎈🎉🎈🎉🎈</div>
            </div>
          </section>
        )}

        {/* Details Section */}
        {activeSection === 'details' && (
          <section className="kids-section details-section">
            <h2 className="section-title">
              🎉 Party Details 🎉
            </h2>

            <div className="details-grid">
              <div className="detail-card">
                <div className="detail-icon">📍</div>
                <h3>Where</h3>
                <p className="venue-name">{invitationData.venue}</p>
                <p className="venue-address">{invitationData.venueAddress}</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">🎭</div>
                <h3>Theme</h3>
                <p className="theme-info">{invitationData.theme}</p>
                <p className="dress-info">{invitationData.dressCode}</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">🎮</div>
                <h3>Activities</h3>
                <p className="activities-info">{invitationData.activities}</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">🎁</div>
                <h3>Gifts</h3>
                <p className="gift-message">Your presence is the best gift!</p>
                <p className="gift-note">But if you'd like, toys are welcome!</p>
              </div>
            </div>

            <div className="countdown-section">
              <h3>🎈 Party Countdown! 🎈</h3>
              <div className="countdown-display">
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Days</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Hours</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Mins</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Secs</span>
                </div>
              </div>
            </div>

            <button 
              className="rsvp-cta-btn"
              onClick={() => setActiveSection('rsvp')}
            >
              ✉️ RSVP Now!
            </button>
          </section>
        )}

        {/* RSVP Section */}
        {activeSection === 'rsvp' && (
          <section className="kids-section rsvp-section">
            <h2 className="section-title">
              ✉️ RSVP ✉️
            </h2>

            <form className="kids-rsvp-form" onSubmit={(e) => e.preventDefault()}>
              <p className="rsvp-intro">Can you make it to the party? 🎉</p>
              <p className="rsvp-deadline">Please let us know by June 1, 2026</p>

              <div className="form-group">
                <label>👤 Your Name</label>
                <input
                  type="text"
                  name="name"
                  value={rsvpData.name}
                  placeholder="Enter your name"
                  disabled={isPreview}
                />
              </div>

              <div className="form-group">
                <label>🎈 Will you join the fun?</label>
                <div className="attendance-options">
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="yes"
                      disabled={isPreview}
                    />
                    <span className="option-icon">🎉</span>
                    <span className="option-text">Yes! I'll be there!</span>
                  </label>
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="no"
                      disabled={isPreview}
                    />
                    <span className="option-icon">😢</span>
                    <span className="option-text">Sorry, can't make it</span>
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label>👨‍👩‍👧‍👦 How many guests?</label>
                <select
                  name="guests"
                  value={rsvpData.guests}
                  disabled={isPreview}
                >
                  <option value="1">1 Guest</option>
                  <option value="2">2 Guests</option>
                  <option value="3">3 Guests</option>
                  <option value="4">4 Guests</option>
                  <option value="5">5 Guests</option>
                </select>
              </div>

              <div className="form-group">
                <label>💬 Message (Optional)</label>
                <textarea
                  name="message"
                  value={rsvpData.message}
                  placeholder="Say something fun!"
                  rows="3"
                  disabled={isPreview}
                />
              </div>

              <button type="submit" className="submit-rsvp-btn" disabled={isPreview}>
                🚀 Send RSVP!
              </button>
            </form>
          </section>
        )}

        {/* Watermark */}
        <div className="kids-watermark">
          <a href="/invitations" className="back-to-templates-btn">Back to Designs</a>
          <p>Created with 💖 by <a href="https://logicatechnology.com" target="_blank" rel="noopener noreferrer">Logica Technology</a></p>
        </div>
      </div>
    </div>
  );
};

export default KidsPartyFun;
